export default "__VITE_ASSET__B9_XkUzn__"